import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-suggestion',
  templateUrl: './suggestion.component.html',
  styleUrls: ['./suggestion.component.scss']
})
export class SuggestionComponent implements OnInit, AfterViewInit {

  private readonly HIDE_DELAY = 1000;

  @Input()
  input: HTMLElement;

  @Input()
  options: string[];

  @Output()
  changeSelection = new EventEmitter<string>();

  @ViewChild('container')
  container: ElementRef;

  keep = false;
  focus = false;
  hover = false;

  constructor() { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.focusListener();
  }

  change(option: string): void {
    this.changeSelection.next(option);
  }

  private focusListener() {

    if (!this.input) {
      setTimeout(() => {
        this.keep = true;
      }, 10);
      return;
    }

    this.container.nativeElement.addEventListener('mouseenter', () => {
      this.keep = true;
    });

    this.container.nativeElement.addEventListener('mouseleave', () => {
      setTimeout(() => {
        this.keep = false;
      }, this.HIDE_DELAY);
    });

    this.input.addEventListener('focus', () => {
      this.focus = true;
    });

    this.input.addEventListener('blur', () => {
      setTimeout(() => {
        this.focus = false;
      }, this.HIDE_DELAY);
    });

    this.input.addEventListener('mouseenter', () => {
      this.hover = true;
    });

    this.input.addEventListener('mouseleave', () => {
      setTimeout(() => {
        this.hover = false;
      }, this.HIDE_DELAY);
    });
  }

}
